/** Top-level workflow classification (architecture / intake). */
export enum WorkflowType {
  /** LDT workflow types */
  /** Specimen → our CLIA lab → scan → LIMS → backend. Create order in portal, no image upload. */
  CLINIC = 'clinic',
  /** Partner lab → LIMS → backend. We create order from LIMS; no create-order in portal, no billing hold. */
  ANCILLARY_LAB = 'ancillary_lab',
  /** Partner/clinic uploads images + order in portal. (Future.) */
  DIRECT_UPLOAD_LAB = 'direct_upload_lab',
  /** Partnering with Tempus for a custom, metastatic-only workflow. */
  TEMPUS = 'tempus',

  /** SaMD workflow types */
  /** SaMD US workflow. */
  SAMD_US = 'samd_us',
  /** SaMD UK workflow. */
  SAMD_UK = 'samd_uk',
  /** SaMD EU workflow. */
  SAMD_EU = 'samd_eu',
  /** SaMD demo workflow (prostate-only, patient PHI on order form). */
  SAMD_DEMO = 'samd_demo',
}
